import PropTypes from "prop-types";
import "./Header.css";
import Logo from "./Logo.jsx";

function Header({ companyName, links }) {
  return (
    <header className="header">
      <a href="#top" className="header__brand" aria-label={`${companyName} home`}>
        <Logo size={40} showWordmark theme="light" />
      </a>
      <nav className="header__nav">
        {links.map((link) => (
          <a key={link.href} href={link.href} className="header__link">
            {link.label}
          </a>
        ))}
      </nav>
      <a href="#contact" className="header__cta">
        Start a project
      </a>
    </header>
  );
}

Header.propTypes = {
  companyName: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string.isRequired,
      href: PropTypes.string.isRequired
    })
  ).isRequired
};

export default Header;
